import { Input } from "@/components/ui/input";
import { decDigits, fmtDecInput, fmtMoneyInput, moneyDigits } from "@/lib/constants";

// Shared formatted numeric input. Raw value stays digits ("50000" / "1250.75");
// the user sees Indonesian grouping ("50.000" / "1.250,75"). mode: "int" | "money" | "decimal".
export function NumInput({ mode = "int", signed = false, value, onValue, ...props }) {
  const display = mode === "decimal" ? fmtDecInput(value) : fmtMoneyInput(value, signed);
  return (
    <Input
      type="text"
      inputMode={mode === "decimal" ? "decimal" : "numeric"}
      {...props}
      value={display}
      onChange={(e) => onValue(mode === "decimal" ? decDigits(e.target.value, e) : moneyDigits(e.target.value, signed))}
    />
  );
}
